<template>
  <ul
    class="match-tabs-wrap"
    v-if="current_match && Object.keys(current_match).length"
  >
    <li :class="['no-select', { active: parentRoute === CFG_MODULES.GAME_PLAN.route }]">
      <a :href="getHrefFor(CFG_MODULES.GAME_PLAN.route)">{{
        translations.game_plan_label
      }}</a>
    </li>
    <li
      :class="[
        'no-select',
        { active: parentRoute === CFG_MODULES.LINEUP.route },
        {
          'btn-disabled':
            parentRoute !== CFG_MODULES.LINEUP.route &&
            !current_match.show_lineup,
        },
      ]"
      ref="lineup-builder"
    >
      <a :href="getHrefFor(CFG_MODULES.LINEUP.route)"
        >{{ translations.lineup_label }}
      </a>
    </li>
    <li
      v-if="current_match && current_match.sport_id == 1"
      :class="['no-select', { active: parentRoute === CFG_MODULES.MATCH_INFO.route }]"
    >
      <a
        v-if="!is_custom_client.status"
        :href="getHrefFor(CFG_MODULES.MATCH_INFO.route)"
        >{{ translations.match_info_label }}
      </a>
    </li>
    <li class="no-select btn-disabled" v-else>
      <a>{{ translations.match_info_label }}</a>
    </li>
    <li
      v-if="current_match"
      :class="['no-select', { active: parentRoute === CFG_MODULES.SCORECARD.route }]">
      <a :href="getHrefFor(CFG_MODULES.SCORECARD.route)">{{translations.scorecard_label}}</a>
    </li>
    <li class="no-select btn-disabled" v-else>
      <a>{{ translations.scorecard_label }}</a>
    </li>
  </ul>
</template>
<script>
import { CFG_MODULES } from "../../../assets/js/config";
import { formatFullUrl } from "../../../assets/js/common";

export default {
  props: ["parentRoute", "current_match"],
  computed: {
    translations() {
      return this.$store.state.translations;
    },
    is_custom_client() {
      return this.$store.state.match_detail_store.is_custom_client;
    },
  },
  data() {
    return {
      CFG_MODULES,
      show_lineup_tooltip: false,
    };
  },
  methods: {
    getHrefFor(route) {
      let match = this.current_match;
      // if(match && match.noLink) { return; }

      if (typeof match !== "undefined") {
        if (typeof route !== "undefined") {
          if (route === CFG_MODULES.LINEUP.route && !match.show_lineup) {
            return;
          }
        }
        let pageRoute = (typeof route === "undefined" ? this.parentRoute : route);
        let matchUrl = formatFullUrl(match, pageRoute);
        return matchUrl;
      }
    },
  },
};
</script>
